export class RawDataSourceModel {
  public rawDataSourceId: number;
  public medicineName: string;
  public productNumber: string;
  public authorisationStatusId: number;
  public rawDataStatusId: number;
  public dataSourceTypeId: number;
}